import { Component, Inject, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GastosComponent } from "./gastos.component";
import { EmployeesListModel } from "../employees-list.model";
import { EmployeesListService } from "../employees-list.service";
import { FicherosEmpleadosService } from "../../../services/employees/ficheros-empleados.service";
import { Option } from "../../../shared/models/option.model";

@Component({
    selector: "gastos-form",
    templateUrl: "gastos-form.component.html",
    standalone: false
})
export class GastosFormComponent implements OnInit {
    // #region Propiedades
    empleados: EmployeesListModel[] = [];
    ficheroPDF: File = null;
    form: UntypedFormGroup = null;
    formDoc: UntypedFormGroup = null;
    imageBase64: string = null;
    nombreArchivo: string = null;
    tipoArchivo: string = null;
    tamanioArchivo: number = null;
    // #endregion

    get tipoGastoOptions(): Option[] {
        return this.ficherosEmpleadosService.tiposGastos.map(t => ({ label: t, value: t }));
    }

    constructor(
        public dialogRef: MatDialogRef<GastosComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialog: MatDialog,
        protected snackBar: MatSnackBar,
        public EmployeesListService: EmployeesListService,
        public ficherosEmpleadosService: FicherosEmpleadosService
    ) {}

    ngOnInit() {
        // Obtención de los empleados ...
        this.EmployeesListService.getList(true).then((data) => {
            this.empleados = data;
            this.inicializarForm();
        });
    }

    // #region Métodos públicos

    cancelar(): void {
        this.dialogRef.close();
    }

    cancelarFormularioImagen(): void {
        this.imageBase64 = null;
        this.nombreArchivo = null;
        this.tipoArchivo = null;
        this.tamanioArchivo = null;

        if (this.form != null) {
            this.form.reset();
        }
        this.cancelar();
    }

    cancelarFormularioDoc(): void {
        this.ficheroPDF = null;

        if (this.formDoc != null) {
            this.formDoc.reset();
        }
        this.cancelar();
    }

    onFileSelected(event) {
        const file: File = event.target.files[0];

        if (file) {
            const reader = new FileReader();

            // Leer el contenido del fichero
            reader.onload = (e: any) => {
                this.imageBase64 = e.target.result;
                this.nombreArchivo = file.name;
                this.tipoArchivo = file.type;
                this.tamanioArchivo = file.size;
            };

            // Leer el fichero como una URL
            reader.readAsDataURL(file);
        }
    }

    onPDFSelected(event) {
        const file: File = event.target.files[0];

        if (file) {
            this.ficheroPDF = file;
        }
    }

    onSubmit(): void {
        if (this.form.valid) {
            // Se comprueba si se ha seleccionado un fichero
            if (this.imageBase64 != null) {
                this.ficherosEmpleadosService.saveImage(
                    this.form.get("employees_Id").value,
                    this.imageBase64,
                    this.form.get("tipoGasto").value,
                    this.tipoArchivo,
                    this.tamanioArchivo,
                    this.nombreArchivo
                );
                this.cancelarFormularioImagen();
            } else {
                this.snackBar.open(
                    "No se ha seleccionado ningún fichero",
                    "Cerrar",
                    {
                        duration: 5000,
                        horizontalPosition: "center",
                        verticalPosition: "bottom",
                    }
                );
            }
        }
    }

    onSubmitDoc(): void {
        if (this.formDoc.valid) {
            // Se comprueba si se ha seleccionado un fichero
            if (this.ficheroPDF != null) {
                this.ficherosEmpleadosService.saveDocument(
                    this.formDoc.get("employees_Id").value,
                    this.ficheroPDF,
                    this.formDoc.get("tipoGasto").value
                );
                this.cancelarFormularioDoc();
            } else {
                this.snackBar.open(
                    "No se ha seleccionado ningún fichero",
                    "Cerrar",
                    {
                        duration: 5000,
                        horizontalPosition: "center",
                        verticalPosition: "bottom",
                    }
                );
            }
        }
    }

    // #endregion

    // #region Métodos privados

    private inicializarForm(): void {
        this.form = new UntypedFormGroup({
            employees_Id: new UntypedFormControl(undefined, [Validators.required]),
            tipoGasto: new UntypedFormControl(undefined, [Validators.required]),
        });

        this.formDoc = new UntypedFormGroup({
            employees_Id: new UntypedFormControl(undefined, [Validators.required]),
            tipoGasto: new UntypedFormControl(undefined, [Validators.required]),
        });
    }

    // #endregion
  public trackByIndex(i: number) { return i; }

}
